import { styled } from "styled-components";
import { padding, rgba } from "polished";
const UtilityItemWrapper = styled("div")(
  ({ theme }) => ({
    alignItems: "center",
    borderRadius: 2,
    cursor: "pointer",
    display: "flex",
    flex: "1 1 0",
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.default,
    lineHeight: theme.lineHeight.default,
    minWidth: 0,
    outline: 0,
    textDecoration: "none",
    whiteSpace: "nowrap",
    transition: "all 0.1s cubic-bezier(.645, .045, .355, 1)"
  }),
  ({ magnitude }) => ({
    medium: {
      ...padding(4, 8)
    }
  })[magnitude],
  ({ disabled, theme }) => ({
    cursor: disabled ? "default" : "pointer",
    color: disabled ? theme.color.gray6 : theme.color.gray8
  }),
  ({ disabled, hoverable, theme }) => hoverable && !disabled ? {
    "&:hover": {
      backgroundColor: theme.color.gray3,
      color: theme.color.gray8,
      zIndex: 1
    },
    "&:active": {
      backgroundColor: theme.color.gray4
    },
    "&:focus": {
      boxShadow: `0 0 0 2px ${rgba("black", 0.05)}`
    }
  } : {},
  ({ highlighted, theme }) => highlighted ? {
    backgroundColor: theme.color.gray3,
    color: theme.color.gray8,
    zIndex: 1,
    "&:active": {
      backgroundColor: theme.color.gray4
    },
    "&:focus": {
      boxShadow: `0 0 0 2px ${rgba("black", 0.05)}`
    }
  } : {}
);
const UtilityItemPrefix = styled("div")(({ disabled }) => ({
  flexBasis: "auto",
  flexGrow: 0,
  flexShrink: 0,
  lineHeight: 1,
  paddingRight: 8,
  opacity: disabled ? 0.5 : 1,
  display: "flex"
}));
const UtilityItemMain = styled("div")({
  flexBasis: 0,
  flexGrow: 1,
  flexShrink: 1,
  overflow: "hidden",
  textOverflow: "ellipsis"
});
const UtilityItemSecondary = styled("div")(({ theme }) => ({
  color: theme.color.gray7,
  flexBasis: "auto",
  flexGrow: 0,
  flexShrink: 0,
  marginLeft: "auto",
  paddingLeft: 8
}));
export {
  UtilityItemMain,
  UtilityItemPrefix,
  UtilityItemSecondary,
  UtilityItemWrapper
};
